<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Consultar tarificador
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- RANGO DE FECHA -->
              <v-col cols="12">
                <v-menu
                  ref="dateRangeMenu"
                  v-model="dateRangeMenu"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dates"
                      required
                      filled
                      rounded
                      class="rounded-small"
                      label="Rango de fecha"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es-us"
                    v-model="dates"
                    :max="new Date().toISOString().substr(0, 10)"
                    range
                    scrollable
                    no-title
                  >
                    <v-spacer></v-spacer>
                    <v-hover v-slot:default="{ hover }">
                      <v-btn
                        text
                        rounded
                        class="mr-1"
                        :color="hover ? 'error' : 'grey'"
                        @click="dateRangeMenu = false"
                        >Cancelar</v-btn
                      >
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                      <v-btn
                        rounded
                        :loading="isLoading"
                        :disabled="isLoading"
                        color="success"
                        :class="hover ? 'shadow-2' : 'shadow-4'"
                        class="px-8"
                        @click="
                          $refs.dateRangeMenu.save(dates),
                            !module.includes('agents') && getExtensionDate()
                        "
                        >ok</v-btn
                      >
                    </v-hover>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <!-- Tipo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="tipo"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.type"
                    :items="[
                      { id: 1, name: 'Simple' },
                      { id: 2, name: 'Detallado' },
                    ]"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-tag"
                    label="Tipo"
                    filled
                    rounded
                  ></v-select>
                </ValidationProvider>
              </v-col>

              <!-- Cliente -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="tarificador"
                  rules=""
                  v-slot="{ errors }"
                >
                  <v-select
                    :disabled="isLoading || isEditMode"
                    v-model="payload.tarificador_id"
                    :items="pricingList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-account"
                    label="Tarificador"
                    filled
                    rounded
                  >
                    <!-- <template slot="selection" slot-scope="data">
                      {{ data.item.name + ", " + data.item.lastNAme }}
                    </template>
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item two-line selectable v-bind="attrs" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.name + ", " + item.lastNAme }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.email }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template> -->
                  </v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            Consultar
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      isLoading: false,
      dateRangeMenu: false,
      pricingList: [],
      payload: {
        dateStart: "",
        dateEnd: "",
        type: null,
        tarificador_id: null,
      },
      dates: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
    };
  },

  created() {
    this.getSelectsInfo();
    // this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.dateStart = "";
      this.payload.dateEnd = "";
      this.payload.type = null;
      this.payload.tarificador_id = null;
      this.dates = [];
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getSelectsInfo() {
      // this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      let endpoints = [`/clients/tarificador-select`];

      await axios
        .all(endpoints.map((endpoint) => PbxHttpClient.get(endpoint)))
        .then((res) => {
          this.pricingList = res[0].data;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async submitForm() {
      this.isLoading = true;

      // const { id, ...payload } = this.payload;

      this.payload.dateStart = this.dates[0];
      this.payload.dateEnd = this.dates[1];

      try {
        const { data } = await PbxHttpClient.post(
          "report-tarificador",
          this.payload
        );
        this.closeDialog(data);
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
        this.isLoading = false;
      }
    },
  },
};
</script>
